# Validation status filter: only shows issues with validation_status = "FAILED"
query IssueDetails($runId: ConditionID!, $issueId: ConditionID!) {
	issues(run_id_eq: $runId, issue_id_eq: $issueId, validation_status_eq: { value: "FAILED" }	) {
		issue_id
		type_name
		summary
		url
		elements__component_id
		elements__selector
		elements__dom_snippet
		elements__id
		elements__page_url
		elements__page_title
		conformance
		environment
		flow
		severity_name
		severity_id
		knowledge_base_link
		tags__id
		tags__description
		tags__link
		description
		run_time
		custom_fields
		screenshot
		elements__bounding_box_top
		elements__bounding_box_left
		elements__bounding_box_width
		elements__bounding_box_height
		property_ids
		note
		validation_status
		regulations__id
		regulations__name
		regulations__success_criteria
		regulations__type
		regulations__url
		tickets__key
		tickets__link
	}
}
